import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./applicationsLanding.scss";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./LandingFooter";

// Import your image (make sure the path is correct)
import ellipsometryImage from "./resources/Image_AppNoteEllipsometer.png";

const ApplicationsLanding = () => {
  // Scroll to top when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="applicationsLanding" className="applicationsLandingContainer">
      <div className="container py-5">
        {/* Navigation */}
        <LandingHeader />

        <div className="row g-3 extra-large-space"></div>

        {/* Main Header */}
        <div className="text-center mt-5">
          <h1 className="fw-bold" style={{ color: "rgb(31,73,125)" }}>
            app.speqqle:{" "}
            <span className="fw-bold" style={{ color: "rgb(0,0,0)" }}>
              one app for all your spectroscopy applications
            </span>
          </h1>
          <p className="text-secondary">
            You want to get specific information from your spectroscopic data?
            Browse our applications to see how app.speqqle can help you with
            that. If you don&apos;t find what you are looking for, please
            contact us!
          </p>
        </div>

        <div className="text-center mb-5">
          <button
            className="btn btn-lg fw-bold text-white"
            style={{
              backgroundColor: "rgb(228,108,10)",
              borderRadius: "10px",
            }}
          >
            Try it out now!
          </button>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* Ellipsometry Section */}
        <div className="section-container">
          <div className="section-content">
            <div className="section-image">
              <img
                src={ellipsometryImage}
                alt="Ellipsometry"
                className="img-fluid rounded"
              />
            </div>
            <div className="section-text section-text-left">
              <h2 className="fw-bold text-black">Ellipsometry</h2>
              <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                Analysis of ellipsometry data to determine the complex
                dielectric constant and refractive index of bulk tungsten
                carbide.
                <br />
                Download{" "}
                <a
                  href="/ApplicationNoteEllipsometry_V5.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <LandingFooter />
    </div>
  );
};

export default ApplicationsLanding;
